// @ts-check

// Vendor imports
const Immutable = require('immutable')
const Redux = require('redux')
const thunkMiddleware = require('redux-thunk').default
// Client V2 common imports
const routerMiddleware = require('client-v2/common/state/router/middleware')

// Type definitions
/** @typedef { import('redux').Store } ReduxStore */
/** @typedef { import('redux').StoreEnhancer } ReduxStoreEnhancer */
/** @typedef { import('./types.d').ConfigureStoreOptions } ConfigureStoreOptions */

module.exports = configureStore

/**
 * @param {ConfigureStoreOptions} options
 * @returns {ReduxStore}
 */
function configureStore(options) {
  let initialState = options.state
  if (typeof options.reviver === 'function' && initialState) {
    initialState = Immutable.fromJS(initialState, options.reviver)
  }
  return Redux.createStore(
    options.reducer,
    initialState,
    configureEnhancer(options)
  )
}

/**
 * @param {ConfigureStoreOptions} options
 * @returns {ReduxStoreEnhancer}
 */
function configureEnhancer(options) {
  const middlewares = [
    thunkMiddleware,
    routerMiddleware,
    ...(options.middlewares || [])
  ]

  let composeEnhancers = Redux.compose
  // Determine if this is running in a web browser
  if (typeof window !== 'undefined') {
    // Setup Redux DevTools Browser Extension (if installed)
    if ('__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' in window) {
      // @ts-ignore We don't care about the type-safety of this; assume it works.
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  return composeEnhancers(
    Redux.applyMiddleware(...middlewares)
  )
}
